import { ReactNode } from 'react';
import { SxProps, Theme, Typography } from '@mui/material';
import { spreadSx } from 'ui-kit/lib/utils/spreadSx';

export const H2 = ({
  children,
  sx,
}: {
  children: ReactNode;
  sx?: SxProps<Theme>;
}) => (
  <Typography
    variant={'h2'}
    sx={[
      {
        fontWeight: { xs: 600, sm: 500 },
        lineHeight: { xs: '18px', sm: '30px', lg: '30px' },
        fontSize: { xs: '14px', sm: '22px', lg: '24px' },
      },
      ...spreadSx(sx),
    ]}
    component={'h2'}
  >
    {children}
  </Typography>
);
